// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const UPLOADING_PHOTOS = "Nahr\u00e1vanie fotiek";
